import { render, staticRenderFns } from "./BindAccountInfos.vue?vue&type=template&id=7c2cdfc6&scoped=true&"
import script from "./BindAccountInfos.vue?vue&type=script&lang=js&"
export * from "./BindAccountInfos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c2cdfc6",
  null
  
)

export default component.exports